//id BINÁRIO
const FUNDO_DISTRIBUICAO = {
    INTERNET: { id: 1, descricao: 'Internet' },
    TERCEIROS: { id: 2, descricao: 'Terceiros' },
    PROPRIA: { id: 4, descricao: 'Propria' }
};

module.exports = FUNDO_DISTRIBUICAO;
